export default "__VITE_ASSET__BgCV9pRe__"